export type HwcgActivationResponse =
  | 'accepted'
  | 'declined'
  | 'resend_24h'
  | 'resend_48h';

export const HWCG_ACTIVATION_CHOICES: {
  value: HwcgActivationResponse;
  label: string;
}[] = [
  { value: 'accepted', label: 'Accept activation' },
  { value: 'declined', label: 'Decline activation' },
  {
    value: 'resend_24h',
    label: 'Request resend activation request in 24 hours',
  },
  {
    value: 'resend_48h',
    label: 'Request resend activation request in 48 hours',
  },
];

/** True when the HWCG activation form can be submitted. */
export function canSubmitHwcgActivationResponse(params: {
  response: HwcgActivationResponse | null;
  comment: string;
  pending?: boolean;
}): boolean {
  if (!params.response || params.pending) return false;
  if (params.response === 'accepted') return true;
  return params.comment.trim().length > 0;
}
